import gql from 'graphql-tag';
import ProductAttributeAllData from '../fragments/ProductAttributeAllData';

export default gql`
query ProductAttribute($code: String) {
    productAttribute(code:$code) {
        ...ProductAttributeAllData
    }
}
${ProductAttributeAllData}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/productAttribute.ts